const hostlink = "https://karma.api.saganir.com"
// const hostlink = "http://localhost:8080"    
export default hostlink